import { useState } from "react";
import { useSnackbar } from "@kitbird/core";
import { UploadMediaI } from "../../../../typings/common";
import { byteToString } from "../../../../utils/common";

const useFileHook = () => {
  const snackbar = useSnackbar();
  const [uploadedMedia, setUploadedMedia] = useState<UploadMediaI[]>([]);

  const processFiles = (files: any) => {
    if (Object.keys(files).length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (event: any) => {
        const val: UploadMediaI = {
          FileName: files[0].name.toLowerCase(),
          FileSize: byteToString(files[0].size as number, "B", false),
          FileSizeString: byteToString(files[0].size as number),
          FileType: files[0].type.toLowerCase(),
          FileUrl: event.target.result.split(",")[1],
          FileProgessSize: 0,
          FileProgress: 0,
        };

        const totalFileSize = [...uploadedMedia, val].reduce(
          (prev, curr) => prev + Number.parseFloat(curr.FileSize.split(" ")[0]),
          0,
        );
        const fileSizeLimit = 10 * 1024 * 1024;
        const isFileSizeAcceptable = fileSizeLimit >= totalFileSize;
        const fileType = val.FileName.split(".").pop() || "";
        const isFileTypeAcceptable = (/\b(png|jpe?g|pdf)\b/i).test(fileType);

        if (isFileSizeAcceptable && isFileTypeAcceptable) {
          setUploadedMedia((currFiles) => [...currFiles, val]);
        } else if (!isFileSizeAcceptable && isFileTypeAcceptable) {
          snackbar.show("Total ukuran file melebihi 10 MB", "error");
        } else if (isFileSizeAcceptable && !isFileTypeAcceptable) {
          snackbar.show("Jenis file tidak sesuai (bukan .png, .jpg, .jpeg, atau .pdf)", "error");
        } else if (!isFileSizeAcceptable && !isFileTypeAcceptable) {
          snackbar.show("Total ukuran file melebihi 10 MB dan jenis file tidak sesuai", "error");
        }
      };
    }
  };

  const onFileBrowse = (e: React.ChangeEvent<HTMLInputElement>) => {
    processFiles(e);
  };

  const doDeleteFileIndex = (i: number) => {
    setUploadedMedia((curr) => {
      const newFiles = [...curr];
      newFiles.splice(i, 1);
      return newFiles;
    });
  };

  return {
    uploadedMedia,
    setUploadedMedia,
    processFiles,
    onFileBrowse,
    doDeleteFileIndex,
  };
};

export default useFileHook;
